import { render, staticRenderFns } from "./AllBackups.vue?vue&type=template&id=0ca82fa0&"
import script from "./AllBackups.vue?vue&type=script&lang=ts&"
export * from "./AllBackups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports